/** spec12 FR9: tiles on the dashboard's free grid, in grid cells. */
export interface GridRect {
  x: number;
  y: number;
  w: number;
  h: number;
}

export const HOME_GRID_COLUMNS = 12;
export const HOME_GRID_MAX_ROWS = 400;

export const rectsOverlap = (a: GridRect, b: GridRect) =>
  a.x < b.x + b.w && b.x < a.x + a.w && a.y < b.y + b.h && b.y < a.y + a.h;

/** True when `rect` lies inside the grid and covers none of `others`. */
export function fitsAt(rect: GridRect, others: readonly GridRect[]): boolean {
  if (rect.x < 0 || rect.y < 0 || rect.x + rect.w > HOME_GRID_COLUMNS) return false;
  if (rect.y + rect.h > HOME_GRID_MAX_ROWS) return false;
  return others.every((other) => !rectsOverlap(rect, other));
}

/** The first free spot for a `w` x `h` tile, row by row from the top left (null when full). */
export function firstFreeSpot(
  w: number,
  h: number,
  others: readonly GridRect[],
): { x: number; y: number } | null {
  for (let y = 0; y + h <= HOME_GRID_MAX_ROWS; y++) {
    for (let x = 0; x + w <= HOME_GRID_COLUMNS; x++) {
      if (fitsAt({ x, y, w, h }, others)) return { x, y };
    }
  }
  return null;
}
